import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
/*{ import ViralSocialGenerator from "../components/ViralSocialGenerator";}*/

/* =========================
   TASK ITEM COMPONENT
========================= */
const TaskItem = ({
  completed,
  title,
  description,
}) => {

  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        padding: 12,
        borderRadius: 10,
        background: completed
          ? "#dcfce7"
          : "#f3f4f6",
        border: completed
          ? "2px solid #22c55e"
          : "2px solid #e5e7eb",
        transition: "0.2s",
      }}
    >

      {/* TOP ROW */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
        }}
      >

        {/* LEFT */}
        <div
          style={{
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          {completed ? "✅" : "⬜"}
          {title}
        </div>

        {/* INFO BUTTON */}
        <button
          onClick={() => setOpen(!open)}
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            border: "none",
            background: "#111827",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: 14,
          }}
        >
          i
        </button>

      </div>

      {/* DESCRIPTION */}
      {open && (
        <div
          style={{
            marginTop: 12,
            background: "#fff",
            padding: 12,
            borderRadius: 8,
            fontSize: 14,
            lineHeight: 1.5,
            color: "#374151",
          }}
        >
          {description}
        </div>
      )}

    </div>
  );
};

const ContestPage = () => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [joined, setJoined] = useState(false);

  const [status, setStatus] = useState(null);

  const [leaderboard, setLeaderboard] = useState([]);

  const [submitting, setSubmitting] = useState(false);

  const [isGuest, setIsGuest] = useState(false);

  // =========================
  // FETCH CONTEST STATUS
  // =========================
  const fetchContestStatus = async () => {

    const token = localStorage.getItem("token");

    if (!token) return;

    try {

      const res = await fetch(
        "https://creator-mvp-hvdx.onrender.com/contest/me",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.ok) {

        const data = await res.json();

        setJoined(true);

        setStatus(data);

      } else {

        setJoined(false);

      }

    } catch (err) {

      console.error(
        "Contest status refresh failed",
        err
      );

      setJoined(false);

    } finally {

      setLoading(false);

    }
  };

  // =========================
  // FETCH LEADERBOARD
  // =========================
  const fetchLeaderboard = async () => {

    try {

      const res = await fetch(
        "https://creator-mvp-hvdx.onrender.com/leaderboard/"
      );

      if (!res.ok) {
        throw new Error("Failed leaderboard");
      }

      const data = await res.json();

      setLeaderboard(data);

    } catch (err) {

      console.error(
        "Leaderboard error:",
        err
      );

    }
  };

  // =========================
  // LIVE EFFECT
  // =========================
  useEffect(() => {

    const token = localStorage.getItem("token");

    // =========================
    // GUEST MODE
    // =========================
    if (!token) {

      setIsGuest(true);

      fetchLeaderboard();

      setLoading(false);

      return;
    }

    // initial load
    fetchContestStatus();

    fetchLeaderboard();

    // =========================
    // LIVE REFRESH
    // =========================
    const interval = setInterval(() => {

      fetchContestStatus();

      fetchLeaderboard();

    }, 10000);

    // cleanup
    return () => clearInterval(interval);

    // eslint-disable-next-line
  }, []);

  // =========================
  // JOIN CONTEST
  // =========================
  const joinContest = async () => {

    if (submitting) return;

    const token = localStorage.getItem("token");

    if (!token) {

      navigate("/login");

      return;
    }

    try {

      setSubmitting(true);

      const res = await fetch(
        "https://creator-mvp-hvdx.onrender.com/contest/join",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            social_post_link: "",
            support_link: "",
            video_link: "",
          }),
        }
      );

      if (!res.ok) {
        throw new Error("Failed to join");
      }

      const data = await res.json();

      setJoined(true);

      setStatus(data);

    } catch (err) {

      console.error(err);

      alert("Failed to join contest");

    } finally {

      setSubmitting(false);

    }
  };

  // =========================
  // LOADING
  // =========================
  if (loading) {

    return (
      <h2>Loading contest... ⏳</h2>
    );
  }

  // =========================
  // TASK PROGRESS
  // =========================
  const completedTasks = [
    status?.task_photo_posted,
    status?.task_asset_created,
    status?.task_support_link_added,
    status?.task_received_support,
    status?.task_video_created,
  ].filter(Boolean).length;

  

  return (

    
    <div className="container">

      {/* =========================
          HERO / BANNER
      ========================= */}
      <div className="card">

        <h1>🔥 Creator-Yard Support Contest</h1>

        <p>
          Win up to <b>₦50,000</b>
        </p>

        <p>
          Keep <b>50%</b> of all support earned during the contest.
        </p>

      </div>

      {/* <ViralSocialGenerator leaderboard={leaderboard} /> */}

      {/* =========================
          LIVE LEADERBOARD
      ========================= */}
      <div className="card">

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <h2 style={{ margin: 0 }}>
            🏆 Live Leaderboard
          </h2>

          <div
            style={{
              fontSize: 12,
              color: "#22c55e",
              fontWeight: "bold",
            }}
          >
            ● LIVE
          </div>
        </div>

        <p
          style={{
            fontSize: 14,
            opacity: 0.7,
            marginBottom: 20,
          }}
        >
          Top earning creators this week
        </p>

        {leaderboard.length === 0 ? (

          <p>No rankings yet.</p>

        ) : (

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 14,
            }}
          >
            {leaderboard.map((user, index) => {

              let badge = "🏅";
              let bg = "#f9fafb";

              if (index === 0) {
                badge = "🥇";
                bg = "#fef3c7";
              }

              if (index === 1) {
                badge = "🥈";
                bg = "#e5e7eb";
              }

              if (index === 2) {
                badge = "🥉";
                bg = "#fed7aa";
              }

              return (
                <div
                  key={user.id}
                  style={{
                    background: bg,
                    borderRadius: 18,
                    padding: 18,
                    border: "1px solid #eee",
                    boxShadow:
                      "0 4px 10px rgba(0,0,0,0.05)",
                  }}
                >

                  {/* TOP ROW */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      marginBottom: 14,
                    }}
                  >

                    <h3
                      style={{
                        margin: 0,
                        fontSize: 22,
                      }}
                    >
                      {badge} #{user.rank_position}
                    </h3>

                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        opacity: 0.7,
                      }}
                    >
                      👤 {user.display_name || `Creator #${user.user_id}`}
                    </div>

                  </div>

                  {/* STATS */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "1fr 1fr 1fr",
                      gap: 10,
                    }}
                  >

                    {/* POINTS */}
                    <div
                      style={{
                        background: "#fff",
                        padding: 12,
                        borderRadius: 12,
                        textAlign: "center",
                      }}
                    >

                      <div
                        style={{
                          fontSize: 20,
                          marginBottom: 6,
                        }}
                      >
                        ⭐
                      </div>

                      <strong
                        style={{
                          fontSize: 18,
                        }}
                      >
                        {user.total_points}
                      </strong>

                      <div
                        style={{
                          fontSize: 12,
                          opacity: 0.6,
                          marginTop: 4,
                        }}
                      >
                        Points
                      </div>

                    </div>

                    {/* SUPPORT */}
                    <div
                      style={{
                        background: "#fff",
                        padding: 12,
                        borderRadius: 12,
                        textAlign: "center",
                      }}
                    >

                      <div
                        style={{
                          fontSize: 20,
                          marginBottom: 6,
                        }}
                      >
                        🍚
                      </div>

                      <strong
                        style={{
                          fontSize: 18,
                        }}
                      >
                        ₦{user.total_support_received}
                      </strong>

                      <div
                        style={{
                          fontSize: 12,
                          opacity: 0.6,
                          marginTop: 4,
                        }}
                      >
                        Support
                      </div>

                    </div>

                    {/* EARNINGS */}
                    <div
                      style={{
                        background: "#fff",
                        padding: 12,
                        borderRadius: 12,
                        textAlign: "center",
                      }}
                    >

                      <div
                        style={{
                          fontSize: 20,
                          marginBottom: 6,
                        }}
                      >
                        💰
                      </div>

                      <strong
                        style={{
                          fontSize: 18,
                        }}
                      >
                        ₦{user.creator_share}
                      </strong>

                      <div
                        style={{
                          fontSize: 12,
                          opacity: 0.6,
                          marginTop: 4,
                        }}
                      >
                        Earned
                      </div>

                    </div>

                  </div>

                </div>
              );
            })}
          </div>

        )}

      </div>

      {/* =========================
          LOGIN NOTICE
      ========================= */}
      {isGuest && (
        <div className="card">

          <h2>🔐 Login Required To Join</h2>

          <p>
            You can still view the leaderboard publicly,
            but you must login to participate.
          </p>

          <button
            className="button"
            onClick={() => navigate("/login")}
          >
            🚀 Login To Join Contest
          </button>

        </div>
      )}

      {/* =========================
          TASKS
      ========================= */}
      <div className="card">

        <h3>📋 Contest Tasks</h3>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            marginTop: 15,
          }}
        >
          
          <TaskItem
            completed={status?.task_photo_posted}
            title="Post content on social media"
            description="
Share your unique contest content on your social media channels 
like TikTok, Instagram, Facebook, or X to start earning support and points."
          />

          <TaskItem
            completed={status?.task_asset_created}
            title="Create Creator-Yard asset"
            description="
Create a Creator-Yard asset for your contest content.
Incluude the Title, Description, and a link to your social post to maximize your reach and support potential. 
This allows you to easily share your support link and track your contest performance."
          />
          <TaskItem
            completed={status?.task_support_link_added}
            title="Add support link to your social media bio"
            description="
Add your unique Creator-Yard support link to your social media 
(TikTok, Instagram, Favebook, or X) bio or any other social media bio."
          />
          <TaskItem
            completed={status?.task_received_support}
            title="Receive your first support"
            description="
Receive your first support from fans, followers, or friends to unlock points and climb the leaderboard."
          />
          <TaskItem
            completed={status?.task_video_created}
            title="Create a short promo video (+5 points)"
            description="
Create a short video (15-30 seconds) promoting 
Creator-Yard or your creator journey.
upload it on TikTok, Reels, or shorts
tagging us at creator-yard @creator_yard 
and using the hashtag #CreatorYardContest to earn an extra 5 points in the contest!"
          />

          
        

        </div>

      </div>

      {/* =========================
          PROGRESS
      ========================= */}
      <div
        style={{
          marginBottom: 20,
          fontSize: 13,
          fontWeight: "bold",
          color:
            completedTasks === 5
              ? "#22c55e"
              : "#6b7280",
        }}
      >
        Progress:
        {" "}
        {completedTasks} / 5 tasks completed
      </div>

      {/* =========================
          JOIN BUTTON / STATUS
      ========================= */}
      {!isGuest && (
        <div className="card">

          {!joined ? (

            <button
              className="button"
              onClick={joinContest}
              disabled={submitting}
            >
              {submitting ? "Joining..." : "🚀 Join Contest"}
            </button>

          ) : (

            <div>

              <h3>✅ You are in the contest</h3>

              <p>
                Status: {status?.contest_status}
              </p>

              <p>
                ⭐ Points: {status?.total_points}
              </p>

              <p>
                🍚 Support Earned:
                ₦{status?.total_support_received}
              </p>

              <p>
                💰 Creator Share:
                ₦{status?.creator_share}
              </p>

            </div>

          )}

        </div>
      )}

      {/* =========================
          VIDEO GUIDE
      ========================= */}
      <div className="card">

        <h3>🎥 Contest Guide Video</h3>

        <p>
          Learn how to join the contest,
          create assets, gain support,
          and rank on the leaderboard.
        </p>

        <a
          href="https://www.tiktok.com/@creator_yard/video/7639777258441329928"
          target="_blank"
          rel="noreferrer"
        >
          ▶ Watch NOW
        </a>

      </div>

      {/* =========================
          POINT SYSTEM
      ========================= */}
      <div className="card">

        <h3>📈 Point System</h3>

        <p>
          🍚 ₦200 Support = +1 Point
        </p>

        <p>
          🍚 ₦500 Support = +2 Points
        </p>

        <p>
          🍚 ₦1000 Support = +5 Points
        </p>

        <hr />

        <p>
          More support = more points = higher rankings.
        </p>

        <p>
          Creators keep <b>50%</b> of all support earned.
        </p>

        <p style={{ color: "orange" }}>
          Contest payouts are processed manually
          by the Creator-Yard team.
        </p>

      </div>

      {/* =========================
          BACK BUTTON
      ========================= */}
      <button
        className="button-secondary"
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

    </div>
  );
};

export default ContestPage;